import { useTranslation } from 'react-i18next'
import { i18n } from '@fs/zion-locale'
import { useFeatureFlag } from '@fs/zion-flags'
import { isArabicCountry } from '../../hooks/useShowArabicExperience'

export default function useGetHelpLinks({ nonReligiousMode, isCoreLanguage, canAddPersonalData }) {
  const { t } = useTranslation()
  // The reason we aren't using showArabicExperience here is because showArabicExperience considers if you are a member and we don't care about that here.
  const { isOn: arabicContactUsFlagOn } = useFeatureFlag('home_footer_arabicContactUsLink')
  const useArabicContactUs = arabicContactUsFlagOn && (isArabicCountry() || i18n.language === 'ar')
  const contactUsLink = useArabicContactUs
    ? `/fieldops/middle-east-contact-us`
    : `/fieldops/familysearch-support-contact-us`

  return {
    id: 'getHelp',
    title: t('nav.getHelp', 'Get Help'),
    subNav: [
      {
        id: 'uComm',
        text: t('nav.links.help.uComm', 'User Community'),
        url: `https://community.familysearch.org/${i18n.language}`,
        linkName: 'ff_help_uComm',
        dataTestId: 'ff_user_comm',
        isNew: false,
        noPrependLocaleCode: true,
        hidden: nonReligiousMode || !isCoreLanguage || !canAddPersonalData,
      },
      {
        id: 'helpCntr',
        text: t('nav.links.help.helpCntr', 'Help Center'),
        url: '/help/helpcenter/',
        linkName: 'ff_help_helpCntr',
        dataTestId: 'ff_help_center',
        isNew: false,
      },
      {
        id: 'contact',
        text: t('nav.contact-us', `Contact Us`),
        url: contactUsLink,
        linkName: 'ff_help_contact',
        dataTestId: 'ff_contact_us',
        isNew: false,
      },
      {
        id: 'account',
        text: t('nav.links.help.account', 'Your Account'),
        url: '/help/helpcenter/familysearch-account',
        linkName: 'ff_help_account',
        dataTestId: 'ff_your_account',
        isNew: false,
      },
      {
        id: 'suggestIdea',
        text: t('nav.links.help.suggestIdea', 'Suggest an Idea'),
        url: `https://community.familysearch.org/${i18n.language}/categories/suggest-an-idea`,
        linkName: 'ff_help_suggestIdea',
        dataTestId: 'ff_suggest_idea',
        isNew: false,
        hidden: !isCoreLanguage || !canAddPersonalData,
      },
    ],
  }
}
